/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useContext, useState } from 'react';

import Avatar from '@uniiverse/library/components/avatar';

import locale from '../organization-select/locale';
import ChevronIcon from '../../assets/account-nav-bar/chevron.svg';
import { OrganizationContext } from './withOrganization';
import currentUserToMembership from '../../helpers/userToMembership';

import styles from './styles.css';

const OrganizationSelect = (props) => {

  const { setSelectedMembership, selectedUser, setSelectedUser } = useContext(OrganizationContext);
  const [ expanded, setExpanded ] = useState(false);

  const onOrganizationChange = (memberships) => {
    setSelectedMembership(memberships)
    setSelectedUser(memberships.owner)
    toggleShowOptions()
  }

  const toggleShowOptions = async () => setExpanded(!expanded);

  const selectedUserId = selectedUser.id

  if (props.memberships.length === 0) return <div/>

  return (
    <div className={`${styles.organizationSelectSelect} ${props.enabled ? '' : styles.organizationSelectDisabled}`}>
      <div className={styles.organizationSelectSelected}
      onClick={()=>{toggleShowOptions()}}>
        <Avatar
          user={selectedUser}
          size="small"/>
        <p className={styles.organizationSelectName}>{selectedUserId === props.currentUser.id ?
          props.intl.formatMessage(locale.myAccount) :  selectedUser.first_name}</p>
        <ChevronIcon className={`${styles.organizationSelectSelectorArrow}
        ${expanded ? styles.expanded : undefined}`} />
      </div>
      <div className={`${styles.organizationSelectDropdown}
      ${expanded ? styles.expanded : styles.closed}`}>
        {props.memberships.map((membership) => (
          <div
          key={membership.owner.id}
          className={`${styles.organizationSelectOption}
          ${selectedUserId === membership.owner.id ? styles.hide : ''}`}
          onClick={() => onOrganizationChange(membership)}>
            <Avatar
              user={membership.owner}
              size="small"/>
            <p className={styles.organizationSelectName}>{membership.owner.first_name}</p>
          </div>
        ))}
        <div
        key={props.currentUser}
        className={`${styles.organizationSelectOption}
        ${selectedUserId === props.currentUser.id ? styles.hide : '' }`}
        onClick={() => onOrganizationChange(currentUserToMembership(props.currentUser))}>
          <Avatar
            user={props.currentUser}
            size="small" />
          <p className={styles.organizationSelectName}>
            {props.intl.formatMessage(locale.myAccount)}
          </p>
        </div>
      </div>
    </div>
  )
}

export default OrganizationSelect;
